<div class="modal-form jeep-promo-modal" *ngIf="showModal" (click)="closeModal($event)">
  <div class="modal-form-dialog">
    <div class="modal-header border-0">
        <span aria-label="Zamknij" (click)="closeModal($event)">
          <span class="icon-x"></span>
        </span>
    </div>
    <div class="jeep-promo-modal-body">
      <div class="container px-3">
        <div class="row">
          <div class="col-12 jeep-promo-modal-body-headline">
            JEEP COMPASS NORTH STAR<br />
            Z pakietem korzyści do 33 100 zł
          </div>
        </div>
      </div>
      <div class="container px-3">
        <div class="row">
          <div class="col-12 pb-3">
            <div class="jeep-promo-modal-box">
              <p class="mb-3">
                Wyjątkowy Jeep® Compass edycji limitowanej North Star z pakietem korzyści do 33 100 zł dla wersji e-Hybrid  obejmującym atrakcyjny rabat w wysokości 24 000 zł oraz wyposażenie o wartości 20 000 zł za 10 900 zł.
              </p>
              <p class="mb-1">
                Wyposażenie o wartości 23 700 zł w specjalnej cenie 10 900 zł:
              </p>
              <ul class="jeep-promo-modal-box-list">
                <li>18" aluminiowe obręcze kół</li>
                <li>Dwuczęściowy panoramiczny dach Command View</li>
                <li>Parksense: przednie i tylne czujniki parkowania</li>
                <li>Czarne relingi dachowe</li>
                <li>Lampy przeciwmgielne LED</li>
                <li>Ciemne szyby w części tylnej</li>
                <li>Naklejka na masce</li>
                <li>Dedykowane czarne detale nadwozia i emblematy</li>
                <li>Dedykowane zielone wykończenie wnętrza North Star</li>
                <li>Wytrzymała, łatwa do czyszczenia tapicerka North Star</li>
              </ul>
              <p>
                Poznaj zaawansowany technologicznie samochód Jeep® Compass i wybierz się na niezapomnianą przejażdżkę. Skorzystaj z finansowania i już teraz sprawdź bezkompromisowe możliwości Jeepa!
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
